export default __webpack_public_path__ + "images/android_hover.17fe7464.svg";